import $ from 'jquery';
import {FAQItem} from './FAQItem';

export class FAQList {
  public static frontend(el: HTMLElement, opt: any) {
    return new this($(el));
  }

  public all: FAQItem[] = [];
  public $elem: JQuery;

  constructor(public $block: JQuery) {
    this.$elem = $block.children('.faq');
    this.init();
  }

  public init() {
    // this.$elem.children('.accordion').each((i, item) => {
    this.$elem.children('details').each((i, item) => {
      this.all.push(new FAQItem(this, $(item)));
    });
  }

  public closeAll() {
    this.all.forEach((i) => {
      if (i.open) {
        i.open = false;
        i.refresh();
      }
    });
  }
}
